import { render } from "./AgentLeavingSummary.vue?vue&type=template&id=6a4bdefa&scoped=true"
import script from "./AgentLeavingSummary.vue?vue&type=script&lang=js"
export * from "./AgentLeavingSummary.vue?vue&type=script&lang=js"

import "./AgentLeavingSummary.vue?vue&type=style&index=0&id=6a4bdefa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4bdefa"]])

export default __exports__